<template>
  <div
    :class="{
      'form-group--error': typeof validate !== 'undefined' && validate.$error,
      'form-group': hasGroup,
    }"
  >
    <label v-if="labelShown" :for="id">
      {{ label }}
      <span class="text-danger" v-if="isRequired"> * </span>
    </label>
    <AutoComplete
      :id="id"
      ref="field"
      :field="field"
      :disabled="disabled"
      :value="value"
      :placeholder="placeholder"
      v-model="inputValue"
      :class="[
        { 'p-invalid': typeof validate !== 'undefined' && validate.$error },
        inputClass,
        'form-control',
      ]"
      :multiple="multiple"
      :dropdown="dropdown"
      :suggestions="suggestions"
      :forceSelection="forceSelection"
      @input="$emit('input', $event)"
      @complete="$emit('complete', $event)"
      @item-select="$emit('item-select', $event)"
      @item-unselect="$emit('item-select', $event)"
      @clear="$emit('clear', $event)"
    />

    <BaseFormMessage
      v-if="typeof validate !== 'undefined'"
      :validate="validate"
      :label="label"
    />
  </div>
</template>

<script>
import AutoComplete from "primevue/autocomplete";
export default {
  components: {
    AutoComplete,
  },

  props: {
    //Dropdown label
    label: {
      type: String,
    },
    id: {
      type: String,
      default: "",
    },
    isRequired: {
      type: Boolean,
      default: false,
    },
    // Dropdown reactive value
    value: {
      type: [String, Object, Array],
      default: "",
    },
    // Dropdown reactive value
    data: Object,
    // Dropdown placeholder
    placeholder: {
      type: String,
      default: "",
    },
    labelShown: {
      type: Boolean,
      default: false,
    },
    inputClass: {
      type: String,
      required: false,
    },
    // Dropdown disabled state
    disabled: {
      type: Boolean,
      default: false,
    },
    validate: {
      type: Object,
      default: () => {
        // This is intentional
      },
    },
    //Dropdown option label
    field: {
      type: String,
      default: "label",
    },
    forceSelection: {
      type: Boolean,
      default: false,
    },
    hasGroup: {
      type: Boolean,
      default: true,
    },
    // Autocomplete dropdown
    multiple: Boolean,
    // Autocomplete dropdown
    dropdown: Boolean,
    // Autocomplete suggestions
    suggestions: {
      type: Array,
      default: null,
    },
    minLength: {
      type: Number,
      default: 1,
    },
    delay: {
      type: Number,
      default: 300,
    },
  },
  computed: {
    inputValue: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
};
</script>
